import {app} from '../app';

class CharLimitDirective implements ng.IDirective {

    restrict = 'A';

    scope = {
        charLimit: '='
    };

    constructor() {

    }

    link(scope, element, attrs) {
        const limit    = scope.charLimit,
              keycodes = [8, 37, 38, 39, 40, 46]; // Except backspace, delete, and arrow keys.

        element.bind('keydown keypress', (event) => {
            // Once the limit has been met or exceeded, prevent all keypresses from working
            if (element.val().length >= limit) {
                if (keycodes.indexOf(event.keyCode) === -1) {
                    event.preventDefault();
                }
            }
        });

    }

    static factory() {
        const _directive   = () => new this();
        _directive.$inject = [];
        return _directive;
    }

}

app.directive('charLimit', CharLimitDirective.factory());